import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Headline from '../../../components/headline/Headline';
import NavigationBar from '../../../components/Navigationbar/Navigationbar';
import { Box, Button, Dropdown, IconButton, Input, Menu, MenuButton, MenuItem, Table, Tooltip, Typography } from '@mui/joy';
import SearchIcon from '@mui/icons-material/Search';
import { post, Token, url } from '../../../Script/Session';
import Upload from '@mui/icons-material/Upload';
import MoreVert from '@mui/icons-material/MoreVert';
function NutzerVereinsdatenViewer() {
    const { id, name } = useParams();
    const [wit, setWit] = useState("90.5%");
    const [searchTerm, setSearchTerm] = useState('');
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
    const [data, setData] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            const body = {
                token: Token.get(),
                action: "gethome",
                targetid: Number(id),
            };

            try {
                const response = await post(body, "/vereinsuserdata/text");
                console.log(response);
                if (response === "LOGOUT") {
                    navigate("/");
                    return;
                }

                setData(JSON.parse(response));
            } catch (error) {
                console.error("Fehler beim Laden der Daten:", error);
            }
        };

        fetchData();
    }, [id, navigate]);

    const update = async () => {
        const body = {
            token: Token.get(),
            action: "gethome",
            targetid: Number(id),
        };

        try {
            const response = await post(body, "/vereinsuserdata/text");
            console.log(response);
            if (response === "LOGOUT") {
                navigate("/");
                return;
            }

            setData(JSON.parse(response));
        } catch (error) {
            console.error("Fehler beim Aktualisieren der Daten:", error);
        }
    };

    const addDatei = (f) => {
        if (!f) return;
        console.log("Uploading...");

        const formData = new FormData();
        const body = {
            token: Token.get(),
            action: "upload",
            targetid: Number(id),
        };

        formData.append("json", JSON.stringify(body));
        formData.append("file", f);

        fetch(url + "/vereinsuserdata/file", {
            method: "POST",
            body: formData,
        })
            .then(res => res.text())
            .then(text => {
                console.log(text);
                if (text === "OK") {
                    update();
                }
            })
            .catch(console.error);
    };

    const handleChange = (e) => {
        const f = e.target.files[0];
        if (f) {
            addDatei(f);
        }
    };

    function deletefile(itemid) {
        let body = {};
        body.token = Token.get();
        body.action = "deletefile";
        body.targetid = Number(id);
        body.objectid = itemid;
        let response = post(body, "/vereinsuserdata/text");
        if (response === "LOGOUT") {
            navigate("/");
            return;
        }
        if (response == "OK"){
            update();
        }




    }

    return (
        <>
            <div style={{
                width: wit,
                position: "fixed",
                flexDirection: "column",
                top: "0",
                right: "0",
                height: "100vh",
                display: "flex",
                alignItems: "center",
                overflowY: "auto"
            }}>
                <Headline title={`Nutzer Dateien von ${name}`} />

                <Box sx={{ width: "100%", display: "flex", justifyContent: "space-evenly", flexDirection: "row", mt: 3 }}>
                    <input
                        type="file"
                        id="file-upload"
                        style={{ display: 'none' }}
                        onChange={handleChange}
                    />
                    <label htmlFor="file-upload">
                        <Tooltip title="Datei auswählen">
                            <IconButton component="span" variant='solid' sx={{ color: "white" }} color="primary">
                                <Upload />
                                <Typography sx={{ ml: 1, color: "white" }}>Datei Hochladen</Typography>
                            </IconButton>
                        </Tooltip>
                    </label>

                    <Input
                        placeholder="Suche..."
                        startDecorator={<SearchIcon />}
                        value={searchTerm}
                        onChange={(e) => {
                            setSearchTerm(e.target.value);
                            setDebouncedSearchTerm(e.target.value);
                        }}
                        sx={{ width: 500 }}
                    />

                    <Button onClick={() => navigate("/page-history/vereinsuserdata_" + id)}>
                        Historie
                    </Button>
                </Box>

                <Table>
                    <thead>
                        <tr>
                            <th>Dateiname</th>
                            <th>Größe</th>
                            <th>Erstellt am</th>
                            <th>Sonstiges</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Array.isArray(data.result) && data.result.length > 0 ? data.result
                            .slice()
                            .sort((a, b) => b.stamp - a.stamp)
                            .filter(item => item.name?.toLowerCase().includes(debouncedSearchTerm.toLowerCase()))
                            .map((item, index) => (
                                <tr key={index}>
                                    <td>{item.name}</td>
                                    <td>{item.size}KB</td>
                                    <td>{item.time}</td>
                                    <td>
                                        <Dropdown>
                                            <MenuButton slots={{ root: IconButton }} slotProps={{ root: { variant: 'outlined', color: 'neutral' } }}>
                                                <MoreVert />
                                            </MenuButton>
                                            <Menu>
                                                <MenuItem
                                                    onClick={() => {
                                                        window.open(
                                                            `${url}/api/filedownload/${item.id}/${item.name}`,
                                                            "_blank",
                                                            "noopener,noreferrer"
                                                        )
                                                    }}


                                                >Herunterladen</MenuItem>
                                                <MenuItem sx={{ color: "red" }} onClick={() => deletefile(item.id)}>Datei löschen</MenuItem>
                                            </Menu>
                                        </Dropdown>



                                    </td>
                                </tr>
                            ))
                            : (
                                <tr>
                                    <td colSpan={4}>Keine Daten vorhanden.</td>
                                </tr>
                            )}
                    </tbody>
                </Table>
            </div>
            <NavigationBar state={"verein"} back={true} />
        </>
    );
}

export default NutzerVereinsdatenViewer;
